import { usePrivy } from '@privy-io/react-auth';
import { useCopyToClipboard } from 'usehooks-ts';
import CopyTextIcon from '../../../svgComponents/CopyTextIcon.jsx';
import Button from '../../../ButtonCustom/index.jsx';
import { SendIcon } from '../../../svgComponents/SendIcon.jsx';
import { ReceiveIcon } from '../../../svgComponents/ReceiveIcon.jsx';
import { ExitIcon } from '../../../svgComponents/ExitIcon.jsx';
import { Tick } from '../../../svgComponents/Tick.jsx';
import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useAppStore } from '../../../../store/appStore.js';
import { useContextProvider } from '../../../../context/index.jsx';
import { BurgerMenu } from '../../../BurgerMenu/index.jsx';
import { CloseIcon } from '../../../svgComponents/CloseIcon.jsx';
import { formatAddress } from '../../../../utils/formatAddres.js';
import {CurrensyList} from './components/CurrensyList.jsx'



export const UserMenu = ({ isOpened, setIsOpened }) => {
  const { exportWallet, user } = usePrivy();
  const { setIsOpenedReceiveModal, setIsOpenedSendModal } = useAppStore();
  const { handleDisconnect, walletAddress } = useContextProvider();
  const [_, copyToClipboard] = useCopyToClipboard();
  const isWalletEmbedded = user?.wallet?.connectorType === 'embedded';
  const [copied, setCopied] = useState(false);

  const handleCopy = (walletAddress) => {
    copyToClipboard(walletAddress);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const smHeight = useMediaQuery('(max-height: 450px)');

  const handleExportWallet = async () => {
    await exportWallet();
  };

  const handleReceiveClick = () => {
    setIsOpened(false);

    setIsOpenedReceiveModal(true);
  };

  const handleOpenSendModal = () => {
    setIsOpened(false);

    setIsOpenedSendModal(true);
  };

  return (
    <BurgerMenu isActive={isOpened} setMenuActive={setIsOpened}>
      <div
        className={`relative flex flex-col justify-start h-full dark:text-white dark:bg-black-main-bg text-black pt-6
      md:pb-[120px] ${smHeight && 'md:pb-0 pt-2'} bg-white w-full overflow-y-hidden`}
      >
        <div className="flex flex-col gap-2">
          <div
            className={`flex gap-2 w-full pb-6 ${smHeight && 'pb-2'} border-b-[1px] border-white-main-bg dark:border-blue-darkMode-20`}
          >
            <div className="flex justify-between items-center w-full px-8">
              <span className="font-Inter font-bold text-[24px] leading-[36px] text-black dark:text-white">
                XBR Account
              </span>

              <button
                className="rounded-8 w-[36px] h-[36px] flex justify-center items-center bg-blue-light-10 dark:bg-blue-darkMode-20"
                onClick={() => setIsOpened(false)}
              >
                <CloseIcon />
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-between overflow-y-auto h-full scrollbar-thin">
          <div className="flex flex-col h-full">
            <div className="flex flex-col mt-3 text-black dark:text-white px-8 border-b-[1px] border-white-main-bg dark:border-blue-darkMode-20 w-full pb-3">
              <h3 className=" text-base font-medium font-Inter leading-[34px]">
                My Funds
              </h3>

              {walletAddress && (
                <div className="bg-blue-light-10 dark:bg-blue-darkMode-20 flex justify-between items-center px-4 py-3 rounded-8 font-Inter font-normal text-sm">
                  <span>{formatAddress(walletAddress, 10, 10)}</span>
                  <span
                    className="text-[#5663F280] dark:text-white cursor-pointer"
                    onClick={() => handleCopy(walletAddress)}
                  >
                    {copied ? (
                      <Tick />
                    ) : (
                      <CopyTextIcon width={15} height={15} />
                    )}
                  </span>
                </div>
              )}
              <div
                className={`w-full block md:hidden ${smHeight && 'md:!block'} mt-[8px]`}
              >
                <button
                  onClick={handleDisconnect}
                  className="text-blue-50 font-Inter font-medium text-sm leading-[18px] mt-3 underline flex gap-1 justify-center w-full"
                >
                  <ExitIcon />
                  Log out
                </button>
              </div>

              <CurrensyList />
              <div className="flex gap-3 mt-6">
                <Button
                  variant="bordered"
                  className="gap-1 font-medium w-full justify-center"
                  onClick={handleOpenSendModal}
                >
                  <SendIcon />
                  Send
                </Button>
                <Button
                  variant="bordered"
                  className="gap-1 font-medium w-full justify-center"
                  onClick={handleReceiveClick}
                >
                  <ReceiveIcon /> Receive
                </Button>
              </div>

              {isWalletEmbedded && (
                <button
                  className="text-blue-50 font-Inter font-medium text-sm leading-[18px] mt-3 underline"
                  onClick={handleExportWallet}
                >
                  Export Wallet
                </button>
              )}
            </div>

          </div>

          <div
            className={`px-8 hidden md:block ${smHeight && 'md:hidden'} w-full absolute bottom-8`}
          >
            <button
              onClick={handleDisconnect}
              className="text-blue-50 font-Inter font-medium text-sm leading-[18px] mt-3 underline flex gap-1 justify-center w-full"
            >
              <ExitIcon />
              Log out
            </button>
          </div>
        </div>
      </div>
    </BurgerMenu>
  );
};
